import HomeFooterMainNavigationList from "../../lists/homeScreen/HomeFooterMainNavigationList";
import SystemNeoUmmiaDarkLogoTextImage from "../../images/SystemNeoUmmiaDarkLogoTextImage";
import {kHomeFooterAboutNavItems, kHomeFooterActivityNavItems} from "../../../constants/navigation";

export default function HomeFooterNavigationLinks() {
    // Used in HomeFooter to display Footer navigation links

    // BUILD
    return (
        <div className={"w-full flex justify-between items-start"}>
            <div className={"w-full flex space-x-[96px] justify-start items-start"}>
                <HomeFooterMainNavigationList title={"Activité"}
                                              navItems={kHomeFooterActivityNavItems} />
                <HomeFooterMainNavigationList title={"À propos"}
                                              navItems={kHomeFooterAboutNavItems} />
            </div>
            <SystemNeoUmmiaDarkLogoTextImage />
        </div>
    )
}